import { isAxiosError } from 'axios';


export interface FieldViolation {
  field: string;
  code: string;
  message: string;
}

/** Normalized error built from the backend's RFC 9457 ProblemDetail ({ code, detail, errors[] }). */
export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    message: string,
    readonly fieldErrors: FieldViolation[] = [],
    readonly requestId?: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export function toApiError(error: unknown): ApiError {
  if (error instanceof ApiError) return error;
  if (isAxiosError(error)) {
    if (!error.response) return new ApiError(0, 'NETWORK', error.message);
    const data = (error.response.data ?? {}) as { code?: string; detail?: string; errors?: FieldViolation[]; requestId?: string };
    return new ApiError(error.response.status, data.code ?? 'UNKNOWN', data.detail ?? error.message, data.errors ?? [], data.requestId);
  }
  return new ApiError(0, 'UNKNOWN', error instanceof Error ? error.message : String(error));
}
